export enum VideoPart {
  Global = 'global',
  Scenes = 'scenes',
  Subtitles = 'subtitles',
  Captions = 'captions',
  Voiceover = 'voiceover',
  // Effects = 'effects',
  Music = 'music',
  Metadata = 'Metadata',
  Jobs = 'jobs',
  EditScene = 'edit-scene',
  EditSceneItem = 'edit-scene-item',
  Thumbnail = 'thumbnail',
}

export const TITLE_BY_VIDEO_PAGE = {
  [VideoPart.Global]: 'Global',
  [VideoPart.Thumbnail]: 'Thumbnail',
  [VideoPart.Scenes]: 'Scenes',
  [VideoPart.Subtitles]: 'Subtitles',
  [VideoPart.Voiceover]: 'Voiceover',
  [VideoPart.Captions]: 'Captions',
  // [VideoPart.Effects]: 'Effects',
  [VideoPart.Music]: 'Music',
  [VideoPart.Metadata]: 'Metadata',
  [VideoPart.Jobs]: 'Jobs',
  [VideoPart.EditScene]: 'Edit Scene',
  [VideoPart.EditSceneItem]: 'Edit Scene',
};

export const BACK_BY_SCENE: {
  [key: string]: VideoPart;
} = {
  [VideoPart.EditScene]: VideoPart.Scenes,
  [VideoPart.EditSceneItem]: VideoPart.Scenes,
};
